module.exports = __webpack_public_path__ + "static/media/STAT100A.87f7b9d2.PNG";